import React from 'react';
import { WeaLocaleProvider } from 'ecCom';

const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header';
import './css/index';

export default class Content_calendar extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@l567m1`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <table id={`weatherTable_${eid}`} style={{ overflow: 'hidden', backgroundColor: 'rgb(255, 255, 255)', width: '100%', tableLayout: 'fixed', textAlign: 'center' }}>
                            <tbody>
                                <tr>
                                    <td style={{ verticalAlign: 'middle', width: '35px' }}>
                                        <div id={`weatherback_${eid}`} className="" />
                                    </td>
                                    <td id="asdad" align="center" style={{ textAlign: 'center' }}>
                                        <div id="weather_577" align="center">
                                            <div id={`weather_${eid}_0`} style={{ margin: '0px auto', overflow: 'hidden', width: '200px', textAlign: 'center' }}>
                                                <table cellPadding="0" cellspace="0" border="0" style={{ textAlign: 'center', margin: '0px auto' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td id={`weather_${eid}_1`} className="valign" style={{ float: 'left' }}>
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="80" style={{ textAlign: 'center' }}>
                                                                                <div className="wetCityName"
                                                                                  style={{ height: '20px' }}
                                                                                >{getLabel(20940, '上海') }
                                                                                </div>
                                                                                <div className="wetCityName" id="curConditionDiv" style={{ width: '80px', cursor: 'pointer', height: '40px', lineHeight: '20px' }}>
                                                                                    <p title={getLabel(501226, '多云')}>{getLabel(501226, '多云') }</p>
                                                                                </div>
                                                                                <div style={{ width: '80px', bottom: '10px' }}>
                                                                                    <img src="/page/element/Weather/resource/image/weather/d01.gif" title={getLabel(501226, '多云')} />
                                                                                </div>
                                                                                <br />{'5℃~0℃'}</td>
                                                                            <td width="80" style={{ textAlign: 'center' }}>
                                                                                <div className="wetCityName" style={{ height: '20px' }}>{getLabel(131471, '北京') }</div>
                                                                                <div className="wetCityName" id="curConditionDiv" style={{ width: '80px', cursor: 'pointer', height: '40px', lineHeight: '20px' }}>
                                                                                    <p title={getLabel(501227, '晴')}>{getLabel(501227, '晴') }</p>
                                                                                </div>
                                                                                <div style={{ width: '80px', bottom: '10px' }}>
                                                                                    <img src="/page/element/Weather/resource/image/weather/d00.gif" title={getLabel(501227, '晴')} />
                                                                                </div>
                                                                                <br />{'2℃~-7℃'}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td id="weather_577_2" className="valign" />
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                    <td valign="middle" style={{ verticalAlign: 'middle', width: '35px' }}>
                                        <div id="weathernext_577" className="" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_weather.js